var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('router-link',{attrs:{"to":_vm.item.link}},[_vm._v(_vm._s(_vm.item.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }